import { Button, Icon } from "@trueskin-web/components"
import { arrowLongRightIcon } from "@trueskin-web/theme/icons/arrowLongRightIcon"

const SubmitButton = ({
  as: Comp = Button,
  isLoading,
  size = "sm",
  isFullWidth = true,
  rounded = true,
  withArrow = true,
  onClick,
  className,
  children,
  ...props
}) => {
  return (
    <Comp
      size={size}
      isFullWidth={isFullWidth}
      rounded={rounded}
      isLoading={isLoading}
      onClick={onClick}
      className={className}
      {...props}
    >
      {children}
      {withArrow && (
        <Icon
          icon={arrowLongRightIcon}
          sx={{ mt: ["2px", 0], mb: [null, "2px"], ml: 1 }}
        />
      )}
    </Comp>
  )
}

export default SubmitButton
